import React, { Component } from 'react';
import AuthService from '../../services/api/auth';
import LoadingModal from '../../components/LoadingModal';
import { withAlert } from 'react-alert';
class ProcessApplicationScreen extends Component {
    componentDidMount() {
        AuthService.processApplication().then(data => {
            this.props.history.push('/register/status');
        });
    }

    render() {
        return (
            <div className="container-fluid wrapper">
                <LoadingModal loading={true} message={'PAYMENT_LOADING_MESSAGE'} />
            </div>
        );
    }
}
export default withAlert(ProcessApplicationScreen);
